module.exports = __webpack_public_path__ + "9cead011a11830107c216b0bc03ad4d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Help/screenshots/AccessPlace - Search - Selected - Desktop.png
// module id = 1042
// module chunks = 0